import FormattedMessage from 'I18n/components/FormattedMessage';
import { ONBOARDING_SALES_FREE, ONBOARDING_STARTER_SALES, ONBOARDING_INVITED_SALES } from 'getting-started-shared-tasks/onboardingKeys';
import { SALES_DATA_ACADEMY_URL, MOBILE_APP_KB_URL, FREE_APP_MARKETPLACE_URL, SALES_STARTER_APP_MARKETPLACE_URL } from '../constants/urls';
import { LEARN_MORE_CTAS } from '../constants/enums';
import { getDefaultSalesTaskGroupOverrides } from '../constants/defaultTaskGroupOverrides';
import { jsx as _jsx } from "react/jsx-runtime";
export default function getSalesViewConfig(__appContexts) {
  return {
    [ONBOARDING_SALES_FREE]: {
      taskGroupOverrides: getDefaultSalesTaskGroupOverrides(),
      learnMore: {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sales.learnMore.description"
        }),
        ctas: [{
          ctaId: LEARN_MORE_CTAS.ACADEMY_SALES_DATA,
          href: SALES_DATA_ACADEMY_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sales.learnMore.ctas.academy-sales-data"
          }),
          icon: 'deals'
        }, {
          ctaId: LEARN_MORE_CTAS.MOBILE_APP_SALES,
          href: MOBILE_APP_KB_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sales.learnMore.ctas.mobile-app-sales"
          }),
          icon: 'mobile',
          external: true
        }, {
          ctaId: LEARN_MORE_CTAS.MARKETPLACE_SALES,
          href: FREE_APP_MARKETPLACE_URL,
          external: true,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sales.learnMore.ctas.app-marketplace-sales"
          }),
          icon: 'marketplace'
        }]
      }
    },
    [ONBOARDING_INVITED_SALES]: {
      taskGroupOverrides: getDefaultSalesTaskGroupOverrides(),
      learnMore: {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sales.learnMore.description"
        }),
        ctas: [{
          ctaId: LEARN_MORE_CTAS.ACADEMY_SALES_DATA,
          href: SALES_DATA_ACADEMY_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sales.learnMore.ctas.academy-sales-data"
          }),
          icon: 'deals'
        }, {
          ctaId: LEARN_MORE_CTAS.MOBILE_APP_SALES,
          href: MOBILE_APP_KB_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sales.learnMore.ctas.mobile-app-sales"
          }),
          icon: 'mobile',
          external: true
        }, {
          ctaId: LEARN_MORE_CTAS.MARKETPLACE_SALES,
          href: FREE_APP_MARKETPLACE_URL,
          external: true,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sales.learnMore.ctas.app-marketplace-sales"
          }),
          icon: 'marketplace'
        }]
      }
    },
    [ONBOARDING_STARTER_SALES]: {
      taskGroupOverrides: getDefaultSalesTaskGroupOverrides(),
      learnMore: {
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sales.learnMore.description"
        }),
        ctas: [{
          ctaId: LEARN_MORE_CTAS.ACADEMY_SALES_DATA,
          href: SALES_DATA_ACADEMY_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sales.learnMore.ctas.academy-sales-data"
          }),
          icon: 'deals'
        }, {
          ctaId: LEARN_MORE_CTAS.MOBILE_APP_SALES,
          href: MOBILE_APP_KB_URL,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sales.learnMore.ctas.mobile-app-sales"
          }),
          icon: 'mobile',
          external: true
        }, {
          ctaId: LEARN_MORE_CTAS.MARKETPLACE_SALES,
          href: SALES_STARTER_APP_MARKETPLACE_URL,
          external: true,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "sales.learnMore.ctas.app-marketplace-sales"
          }),
          icon: 'marketplace'
        }]
      }
    }
  };
}